import BaseProxy from './Proxy';

export default class BarringProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/barring', parameters);
  }

  getProfileStatus() {
    return this.submit('get', `${this.endpoint}/profile/status`);
  }

  getProfileHistory() {
    return this.submit('get', `${this.endpoint}/profile/history`);
  }

  getHistoryDetails(businessModel, validAt) {
    return this.submit('get', `${this.endpoint}/profile/${businessModel}/history/${validAt}`);
  }

  getPartner(partnerNumber) {
    return this.submit('get', `${this.endpoint}/partners/${partnerNumber}`);
  }

  getCategory(contentTypeCode) {
    return this.submit('get', `${this.endpoint}/categories/${contentTypeCode}`);
  }

  setPin(params) {
    return this.submit('post', `${this.endpoint}/pin`, params);
  }
}
